module.exports = __webpack_public_path__ + "static/media/SC.dbb8b5b2.svg";